// extracted by mini-css-extract-plugin
export var disabled = "_ry-0";